export default __webpack_public_path__ + "static/media/egg.e568f07b.png";